'use client';

import { Fragment } from 'react';
import { Container } from '@/components/common/container';
import { PrivacyPolicyContent } from './content';

export default function PrivacyPolicyPageClient() {
  return (
    <Fragment>
      <Container>
        <PrivacyPolicyContent />
      </Container>
    </Fragment>
  );
}
